import { Runtime } from '@/core/enums/runtime.enum'
import { PACKAGE_MANAGER_MAP } from '@/core/utils/installation'

import { getCodeSnippetLanguage } from './technologies'

export function getHostedModuleCodeSnippetLanguage(runtimeName: string | undefined): string {
  if (!runtimeName || !(runtimeName in PACKAGE_MANAGER_MAP)) {
    return 'plainText'
  }

  return getCodeSnippetLanguage(PACKAGE_MANAGER_MAP[runtimeName as Runtime])
}
